/* The procurement screens (docs/plans/phase2-procurement.md §5). Tokens only. */

.flags {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.flags li {
  overflow-wrap: anywhere;
}
